export default "__VITE_ASSET__OvIdgR0B__"